<lib-forgot-password [callerProject]="projectName"></lib-forgot-password>
